import BouncingArrow from "./BouncingArrow";
import PropTypes from "prop-types";
import React from "react";
import injectSheet from "react-jss";

const styles = () => ({
  heroContainer: {
    height: "calc(100vh - 84px)",
    width: "100%",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
  },
  heroImgWithProductHeader: {
    height: "calc(100vh - (84px + 3.11rem))",
    width: "100%",
    top: "0",
    left: "0"
  },
  heroTextContainer: {
    zIndex: "3",
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center"
  },
  heroTextContainerWithProductHeader: {
    "@media (max-width: 412px)": {
      top: "calc(3.11rem + 150px)"
    }
  },
});

const Hero = ({ classes, hero, withBar, children }) => (
  <div
    className={classes.heroContainer}
    style={{ backgroundImage: `url(${hero})` }}
  >
    <div
      className={`${classes.heroTextContainer} ${withBar &&
        classes.heroTextContainerWithProductHeader}`}
    >
      {children}
    </div>
  </div>
);

Hero.propTypes = {
  classes: PropTypes.object,
  children: PropTypes.node,
  hero: PropTypes.string.isRequired,
  withBar: PropTypes.bool
};

export default injectSheet(styles)(Hero);



// WEBPACK FOOTER //
// ./src/components/Hero/Hero.jsx